import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal"
import luckyWinnerRoundModel from "@/models/lucky-winner/lucky-winner-round"
import router from "@/router"
import store from "@/store"
import useFlatPickr from "@/utils/hooks/useFlatPickr"
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable"
import usePagination from "@/views/components/pagination/usePagination"
import { onBeforeMount, reactive, ref, watch } from "@vue/composition-api"

export default function useLuckyWinnerRoundList() {
  const { createRound, editRound, fetchRoundDetail, fetchRoundList, setRoundStatus } = luckyWinnerRoundModel()

  const { pagination, onPageChange, onFilterEntity } = usePagination()
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const loading = reactive({
    tableData: false,
  })

  const campaignId = ref(null)

  const fields = [
    { key: "seq", label: "No" },
    { key: "description", label: "Description" },
    { key: "announcement_date", label: "Announcement Date" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ]

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ])

  const status = ref(0)

  const roundListTable = reactive({
    payload: [],
  })

  const fetchLuckyWinnerRoundList = () => {
    loading.tableData = true
    fetchRoundList.payload.CampaignId = campaignId.value
    fetchRoundList.payload.Page = pagination.currentPage
    fetchRoundList.payload.Limit = pagination.perPage
    fetchRoundList.payload.Filters = filters
    store
      .dispatch('api/apiRequest', fetchRoundList)
      .then(response => {
        if(response.status == "success") {
          roundListTable.payload = response.data.resp.map((item) => ({
            seq: item.id,
            description: item.description,
            announcement_date: `${resolveDate(item.startdate)} ${resolveTime(item.startdate)}`,
            status: item.status
          }))
          pagination.rows = response.data.resp.length
          pagination.totalRows = response.data.filtered_record??response.data.resp.length
        }
    })
    .catch(error => {
      openDefaultErrorModal(error)
    })
    .finally(() => {
      loading.tableData = false
    })
  }

  const onToggleStatus = (status, reward) => {
    loading.tableData = true
    setRoundStatus.payload.Id = reward.seq
    setRoundStatus.payload.CampaignId = campaignId.value
    setRoundStatus.payload.Status = reward.status
    store
      .dispatch('api/apiRequest', setRoundStatus)
      .then(response => {
        if(response.status == "success") {
          reward.status = !reward.status
        }
    })
    .catch(error => {
      openDefaultErrorModal(error)
    })
    .finally(() => {
      loading.tableData = false
    })
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchLuckyWinnerRoundList()
      }
    },
    { deep: true }
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchLuckyWinnerRoundList()
    },
    { deep: true }
  )

  onBeforeMount(() => {
    campaignId.value = router.currentRoute.params.campaignId

    fetchLuckyWinnerRoundList()
  })

  return {
    campaignId,
    fields,
    loading,
    statusOption,
    status,
    roundListTable,
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    onToggleStatus,
  }
}
